export enum ConfigMeta {
  OEL_CAAD_BANCAIRE_ACTIF = 'oel-caad-bancaire-actif',
  OEL_URL_SECURITE = 'oel-url-securite',
  OEL_URL_PLANIFIER_APPEL = 'oel-url-planifier-appel',
  OEL_URL_RETOUR_EXTERNE = 'oel-url-retour-externe',
}
